import { lazy } from "react";
import ErrorBoundary from "@/hoc/ErrorBoundary/ErrorBoundary.jsx";

const AIAgentChatBot = lazy(() => import("./index.jsx"));

export const aiAgentChatBotRoutes = {
  children: [
    {
      path: "ai-agent-chat-bot",
      element: <AIAgentChatBot />,
      errorElement: <ErrorBoundary />
    }
  ]
};
